module.exports = __webpack_public_path__ + "img/6.b4d7941a.png";